import RevisionTemplatesTable from 'components/tables/data/revision-template/RevisionTemplatesTable';
import DashboardLayout from 'layouts/dashboard/DashboardLayout';

/**
 * The page for listing all revision templates.
 */
export default function RevisionTemplatesPage() {
  return (
    <DashboardLayout height="screen" breadcrumbs={[{ title: 'Nastavenia' }, { title: 'Šablóny revíznych správ' }]}>
      <RevisionTemplatesTable />
    </DashboardLayout>
  );
}
